import { MDSMenuItemHeaderProps, MDSMenuItemHeaderVariant } from "./menu-item-header.types";
import { StyledHeader } from "./menu-item-header.style";

/**
 * MDSMenuItemHeader
 * This component can be used in both ActionMenu and SelectMenu
 */
export const MDSMenuItemHeader = ({ label, variant }: MDSMenuItemHeaderProps) => {
  return (
    <StyledHeader aria-label={label} $variant={variant ?? MDSMenuItemHeaderVariant.Beginning}>
      {label}
    </StyledHeader>
  );
};
